module.exports = __webpack_public_path__ + "img/mail-icon.a8c9d5a5.svg";